import axios from 'axios'

export default {
  getUsers(page, filter, sorting) {
    return axios.get('/api/users',
      {
        params: {
          page: page,
          email: filter.email,
          userName: filter.userName,
          sortBy: sorting.sortBy,
          sortOrder: sorting.sortOrder
        }
      });
  },
  getUser(id) {
    return axios.get(`/api/users/${id}`);
  },
  saveUser(id, user) {
    if (id) {
      return axios.put(`/api/users/${id}`, user);
    }
    return axios.post('/api/users', user);
  },
  deleteUser(id) {
    console.log(`/api/users/${id}`);
    return axios.delete(`/api/users/${id}`);
  },
  resetPassword(userId) {
    return axios.post(`api/users/reset/${userId}`)
  }
}



// WEBPACK FOOTER //
// ./ClientApp/app/masters/users/api.js